const COLORS = {
    PRIMARY: '#c54644',
    SECONDARY: '#ce9952',
    SUCCESS: '#3f8600',
    DANGER: '#cf1322'
};

export default COLORS;
